// Profile info
export const USER_NAME_MIN_LEN = 1;
export const USER_NAME_MAX_LEN = 120;
export const USERNAME_MIN_LEN = 2;
export const USERNAME_MAX_LEN = 20;
export const USER_AGE_MIN_YEARS = 13;
export const USER_PASSWORD_MIN_LEN = 8;
export const USER_PASSWORD_MAX_LEN = 36;
export const USER_EMAIL_MIN_LEN = 5;
export const USER_EMAIL_MAX_LEN = 45;
export const USER_GOALS_MIN_LEN = 1;

export const USER_BASIC_INFO_STATUS_MAX_LEN = 150;
export const USER_BASIC_INFO_TEXT_MAX_LEN = 2500;

export const USER_LANGUAGES_MAX_LEN = 20;
export const USER_COUNTRIES_MAX_LEN = 20;

// Account deletion
export const ACCOUNT_DELETION_REASON_MAX_LEN = 10000;

// Comments
export const COMMENT_MAX_LEN = 1000;
export const PHOTO_COMMENTS_LIMIT = 5;
export const POST_COMMENTS_LIMIT = 5;
export const REPLIES_LIMIT = 3;

// Interests
export const INTERESTS_DESCRIPTION_MIN_LEN = 50;
export const INTERESTS_DESCRIPTION_MAX_LEN = 10000;
export const INTERESTS_TEXT_MAX_LEN = 2500;

// Trips
export const TRIP_DESCRIPTION_MAX_LEN = 500;

// Groups
export const GROUP_NAME_MIN_LEN = 1;
export const GROUP_NAME_MAX_LEN = 128;
export const GROUP_DESCRIPTION_MAX_LEN = 500;

// Report reason length limit
export const REPORT_REASON_MAX_LEN = 500;

// Moderation recent content
export const MODERATION_RECENT_CONTENT_LIMIT = 15;

// Moderation user search
export const USERNAME_SEARCH_MAX_LEN = 20;
export const UID_MAX_LEN = 20;
export const IP_SEARCH_MAX_LEN = 39;
export const EMAIL_SEARCH_MAX_LEN = 45;

// Moderation settings
export const IP_MAX_LEN = 39;
export const PATTERN_MAX_LEN = 60;
export const WARNING_MAX_LEN = 38;

// Moderation actions
export const MOD_ADMIN_ACTION_MESSAGE_MAX_LEN = 1000;
export const WARNING_MESSAGE_MAX_LEN = 1000;
export const APPROVE_MESSAGE_MAX_LEN = 1000;
export const DELETE_MESSAGE_MAX_LEN = 1000;
export const SHADOWBAN_MESSAGE_MAX_LEN = 1000;
export const RESTORE_MESSAGE_MAX_LEN = 1000;
export const IP_COMMENT_MAX_LEN = 1000;
export const TEXT_FILTER_COMMENT_MAX_LEN = 1000;
export const DOMAIN_MAX_LEN = 60;
export const DOMAIN_COMMENT_MAX_LEN = 1000;

// Interests modal
export const SELECTED_TAG_LIMIT = 25;

// Adsense redirect limits
export const ADS_MAX_PUBSTREAM_VIEWS_TIER_1_2 = 20;
export const ADS_MAX_PUBSTREAM_VIEWS_TIER_3 = 5;

// Chat
export const MESSAGES_LIMIT = 25;
export const THREADS_LIMIT = 15;

// Albums
export const ALBUM_TITLE_MAX_LENGTH = 100;
export const ALBUM_DESCRIPTION_MAX_LENGTH = 255;

// Friends
export const PAGE_LIMIT = 10;
